import { dayjs } from "Config/dayjs";

export const ConventionChecker = {
  exactLengthCheck: (value: string, convention: API_FilenameAssistantConventionResponse) => {
    value = value || "";
    return !convention.exactLength || value.length === convention.length;
  },

  typeMatchers: {
    STRING: (value: string, convention: API_FilenameAssistantConventionResponse, vaildval?) => {
      return !vaildval || value === vaildval.name;
    },
    PATTERN: (value: string, convention: API_FilenameAssistantConventionResponse, vaildval?) => {
      return new RegExp(`^${vaildval.name}$`).test(value);
    },
    NUMMER: (value: string, convention: API_FilenameAssistantConventionResponse) => {
      return new RegExp("[0-9]{" + convention.length + "}").test(value);
    },
    DATUM: (value: string, convention: API_FilenameAssistantConventionResponse, vaildval?) => {
      return dayjs(value, vaildval.name.toUpperCase(), true).isValid();
    },
  },
  // tofix
  check: (value: string, conventions: API_FilenameAssistantConventionResponse[], multiConv?: boolean[]): boolean => {
    let toCheckValue: string = value;
    let toCheckIndex: number = 0;
    let multiConvRetValue: boolean = true;
    for (const convention of conventions) {
      if (convention.multiConv) {
        return ConventionChecker.check(value, convention.conventions, []);
      } else if (convention.validValues !== null) {
        if (multiConv) {
          // tofix
          toCheckValue = value.substr(toCheckIndex, convention.length === -1 ? undefined : convention.length);
          toCheckIndex += convention.length;
        }
        let hasMatch: boolean = false;
        for (const vaildVal of convention.validValues) {
          if (
            ConventionChecker.exactLengthCheck(toCheckValue, convention) &&
            ConventionChecker.typeMatchers[convention.format](toCheckValue, convention, vaildVal)
          ) {
            if (multiConv) {
              hasMatch = true;
              multiConv.push(true);
              break;
            }
            return true;
          }
        }
        if (multiConv && !hasMatch) {
          multiConv.push(false);
          multiConvRetValue = false;
        }
      } else {
        if (
          ConventionChecker.exactLengthCheck(toCheckValue, convention) &&
          ConventionChecker.typeMatchers[convention.format](toCheckValue, convention)
        ) {
          return true;
        }
      }
    }
    return multiConv ? multiConvRetValue : false;
  },
};
